import React, { useState } from 'react';
import { Share, X } from "lucide-react";

const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

export const InstallHint = () => {
  const [show, setShow] = useState(() => isIOS() && !isStandalone() && !localStorage.getItem('lbt-install-hint-dismissed'));
  if (!show) return null;
  const dismiss = () => { localStorage.setItem('lbt-install-hint-dismissed', '1'); setShow(false); };
  return (
    <div className="mb-6 p-4 rounded-xl bg-emerald-900 text-emerald-50 flex items-start gap-3" data-testid="install-hint">
      <Share className="w-5 h-5 mt-0.5 flex-shrink-0" />
      <p className="text-sm flex-1">
        Install Lil Bear Tracks on your iPhone: tap <strong>Share</strong> in Safari, then <strong>Add to Home Screen</strong>.
      </p>
      <button onClick={dismiss} aria-label="Dismiss" data-testid="install-hint-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
};
